module.exports = __webpack_public_path__ + "img/header-weddingRingsStylesElegant.20e3b81.jpg";